import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type LoginForm } from "./types";

export default {
  init: (
    apiInfo: ModuleApiInfo,
    args: LoginForm.Api.InitRequest
  ): Promise<HttpApiResponse<LoginForm.Api.InitResponse>> =>
    api.get<LoginForm.Api.InitResponse>(apiInfo, `/api/site/v1/modules/login`, { ...args, ...apiInfo.baseParams }),
  login: (
    apiInfo: ModuleApiInfo,
    args: LoginForm.Api.LoginRequest
  ): Promise<HttpApiResponse<LoginForm.Api.LoginResponse>> =>
    api.post<LoginForm.Api.LoginResponse>(apiInfo, `/api/site/v1/modules/login`, { ...args, ...apiInfo.baseParams }),
  resendLink: (
    apiInfo: ModuleApiInfo,
    args: LoginForm.Api.ResendLinkRequest
  ): Promise<HttpApiResponse<LoginForm.Api.ResendLinkResponse>> =>
    api.post(apiInfo, `/api/site/v1/modules/login/resendLink`, { ...args, ...apiInfo.baseParams }),
  resetPassword: (
    apiInfo: ModuleApiInfo,
    args: LoginForm.Api.ResetPasswordRequest
  ): Promise<HttpApiResponse<LoginForm.Api.ResetPasswordResponse>> =>
    api.post(apiInfo, `/api/site/v1/modules/login/resetPassword`, { ...args, ...apiInfo.baseParams }),
  sendResetLink: (apiInfo: ModuleApiInfo, args: LoginForm.Api.SendResetLinkRequest): Promise<HttpApiResponse<void>> =>
    api.post(apiInfo, `/api/site/v1/modules/login/sendResetLink`, { ...args, ...apiInfo.baseParams })
};
